import api from "../../core/app/api";

export const getMetadataRequest = async () => api.get("metadata");
